import { useEffect, useState } from "react";
import {
  Table,
  ScrollArea,
  Card,
  Button,
  Modal,
  LoadingOverlay,
  Grid,
  Stack,
  Select,
  createStyles,
  Group,
  Paper,
  SimpleGrid,
  Text,
  Image,
} from "@mantine/core";
import { useQuery } from "@apollo/client";
import Map from "components/utilities/Map";

import { customLoader } from "components/utilities/loader";
import { GET_PRODUCT, GET_SHIPMENTS } from "apollo/queries";
import { UserPlus, Discount2, Receipt2, Coin } from "tabler-icons-react";
import { useViewportSize } from "@mantine/hooks";
import axios from "axios";
import { Box } from "@mui/material";
import { API } from "utiles/url";

const useStyles = createStyles((theme) => ({
  root: {
    padding: theme.spacing.xl * 1.5,
  },

  value: {
    fontSize: 17,
    fontWeight: 500,
    lineHeight: 1,
  },

  diff: {
    lineHeight: 1,
    display: "flex",
    alignItems: "center",
  },

  icon: {
    color:
      theme.colorScheme === "dark"
        ? theme.colors.dark[3]
        : theme.colors.gray[4],
  },

  title: {
    fontWeight: 700,
    textTransform: "uppercase",
  },
}));

const icons = {
  user: UserPlus,
  discount: Discount2,
  receipt: Receipt2,
  coin: Coin,
};

function CommisstionDetailModal({ commisstion }) {
  // state variables
  const { classes } = useStyles();

  const { height } = useViewportSize();
  return (
    <ScrollArea style={{ height: height / 1.8 }} type="auto" offsetScrollbars>
      <div style={{ width: "98%", margin: "auto" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            p: 1,
            m: 1,
            bgcolor: "background.paper",
            borderRadius: 1,
          }}
        >
          <Card style={{ width: "40%" }} shadow="sm" radius="md" withBorder>
            <div style={{ paddingLeft: "20px" }}>
              <Group align="flex-end" spacing="xs" mt={25}>
                <Text size="sm" weight={500} className={classes.diff}>
                  <span>
                  Calculation Type<span style={{ marginLeft: "5px" }}>:</span>
                  </span>
                </Text>
                <Text className={classes.value}>
                  {commisstion?.calculation_type}
                </Text>
              </Group>

              <Group align="flex-end" spacing="xs" mt={25}>
                <Text size="sm" weight={500} className={classes.diff}>
                  <span>
                  Subscription Fee Amount<span style={{ marginLeft: "5px" }}>:</span>
                  </span>
                </Text>
                <Text className={classes.value}>
                  {commisstion?.subscription_fee_amount}
                </Text>
              </Group>
              <Group align="flex-end" spacing="xs" mt={25}>
                <Text size="sm" weight={500} className={classes.diff}>
                  <span>
                  Fee Interval<span style={{ marginLeft: "5px" }}>:</span>
                  </span>
                </Text>
                <Text className={classes.value}>
                  {commisstion?.fee_interval}
                </Text>
              </Group>
              <Group align="flex-end" spacing="xs" mt={25}>
                <Text size="sm" weight={500} className={classes.diff}>
                  <span>
                  Fee On Date<span style={{ marginLeft: "5px" }}>:</span>
                  </span>
                </Text>
                <Text className={classes.value}>
                  {commisstion?.fee_on_date}
                </Text>
              </Group>
            </div>
          </Card>
        </Box>
      </div>
    </ScrollArea>
  );
}

export default CommisstionDetailModal;
